import { Module } from 'vuex';
import { ShiftCMSState } from '@/store';
import municipalityService from '@/services/municipality.service';
import { Municipality } from '@/models/municipality.model';
import communityService from '@/services/community.service';
import { Community } from '@/models/community.model';

export interface MunicipalityStoreState {
  municipalities: Municipality[];
}

export enum MunicipalitiesMutations {
  SetMunicipalities = 'ms/SetMunicipalities',
}

export enum MunicipalitiesActions {
  GetMunicipalities = 'ms/GetMunicipalities',
  GetMunicipality = 'ms/GetMunicipality',
  AddMunicipality = 'ms/AddMunicipality',
  UpdateMunicipality = 'ms/UpdateMunicipality',
  DeleteMunicipality = 'ms/DeleteMunicipality',
  GetNeighbourhood = 'ms/GetNeighbourhood',
  AddNeighbourhood = 'ms/AddNeighbourhood',
  UpdateNeighbourhood = 'ms/UpdateNeighbourhood',
  DeleteNeighbourhood = 'ms/DeleteNeighbourhood',
  AddCommunity = 'ms/AddCommunity',
  UpdateCommunity = 'ms/UpdateCommunity',
  GetCommunity = 'ms/GetCommunity',
  DeleteCommunity = 'ms/DeleteCommunity',
}

const sn = (str: MunicipalitiesActions | MunicipalitiesMutations): string =>
  str.replace(/ms\//g, '');

export const municipalityStore: Module<MunicipalityStoreState, ShiftCMSState> =
  {
    namespaced: true,
    state: {
      municipalities: [],
    },
    mutations: {
      [sn(MunicipalitiesMutations.SetMunicipalities)](
        state,
        municipalities: Municipality[],
      ) {
        state.municipalities = municipalities;
      },
    },
    actions: {
      async [sn(MunicipalitiesActions.GetMunicipalities)]({ commit }) {
        const res = await municipalityService.getList();
        if (res.status) {
          commit(sn(MunicipalitiesMutations.SetMunicipalities), res.data);
        }
      },
      async [sn(MunicipalitiesActions.GetMunicipality)](_, id: number) {
        const res = await municipalityService.get(id);
        if (res.status) {
          return res.data;
        }
      },
      async [sn(MunicipalitiesActions.AddMunicipality)](_, muni: Municipality) {
        const res = await municipalityService.create({
          ...muni,
          id: undefined,
        });

        return res.status;
      },
      async [sn(MunicipalitiesActions.UpdateMunicipality)](
        _,
        muni: Municipality,
      ) {
        const res = await municipalityService.edit(muni);

        return res.status;
      },
      async [sn(MunicipalitiesActions.AddCommunity)](_, comm: Community) {
        const res = await communityService.create(comm);

        return res.status;
      },
      async [sn(MunicipalitiesActions.UpdateCommunity)](_, comm: Community) {
        const res = await communityService.edit(comm);

        return res.status;
      },
      async [sn(MunicipalitiesActions.DeleteCommunity)](_, comm: Community) {
        const res = await communityService.delete(comm.id);

        return res.status;
      },
      async [sn(MunicipalitiesActions.DeleteMunicipality)](
        _,
        muni: Municipality,
      ) {
        const res = await municipalityService.delete(muni.id);

        return res.status;
      },
    },
  };
